import { render } from "./emoji_grid.vue?vue&type=template&id=a7fa5cc2"
import script from "./emoji_grid.js?vue&type=script&lang=js&external"
export * from "./emoji_grid.js?vue&type=script&lang=js&external"

import "./emoji_grid.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__